<template>

  <div hide-footer @cancel="onCancel" size="lg">
    <b-card>
      <b-form @submit.prevent="submitForm">
        <div class="row">
          <b-form-group class="col-3" label="Código:" label-for="codigo">
            <b-form-input id="codigo" v-model="terapia.codigo" type="text" required />

          </b-form-group>

          <b-form-group class="col-9" label="Nombre:" label-for="nombre">

            <b-form-input id="nombre" v-model="terapia.nombre" type="text" required />
          </b-form-group>
        </div>
        <hr>
        <div class="row">
          <b-form-group class="col-6" label-for="tipoTerapiaId">
            <label>Tipo de terapia:</label>
            <v-select
              id="tipoTerapiaId"
              v-model="terapia.tipoTerapiaId"
              :options="tipoTerapias"
              :reduce="option => option.value"
              label="text"
              placeholder="Seleccionar tipo"
              class="d-inline-block w-100"
            />
          </b-form-group>
        </div>
        <hr>
        <span>Precios:</span>
        <div class="row p-1 align-items-center">
          <div class="col-2">
            <span>Iess</span>
            <b-form-input id="precioiess" v-model="terapia.precioJson.iess_n1" type="text" @keypress="soloNumeros"
              required />
          </div>
          <div class="col-2">
            <span>Issfa N1</span>
            <b-form-input id="precioiess" v-model="terapia.precioJson.issfa_n1" type="text" @keypress="soloNumeros"
              required />
          </div>
          <div class="col-2">
            <span>Issfa N2</span>
            <b-form-input id="precioiess" v-model="terapia.precioJson.issfa_n2" type="text" @keypress="soloNumeros"
              required />
          </div>
          <div class="col-2">
            <span>Isspol</span>
            <b-form-input id="precioiess" v-model="terapia.precioJson.isspol_n1" type="text" @keypress="soloNumeros"
              required />
          </div>
          <div class="col-2">
            <span>Particular</span>
            <b-form-input id="precioiess" v-model="terapia.precioJson.particular" type="text" @keypress="soloNumeros"
              required />
          </div>
        </div>
        <hr>
        <span>Activo/Inactivo</span>
        <div class="row p-1">
          <b-form-group class="col" label="Iess:" label-for="estado-1">
            <b-form-checkbox id="estado-1" v-model="terapia.estadoJson.iess" switch />
          </b-form-group>
          <b-form-group class="col" label="Issfa:" label-for="estado-2">
            <b-form-checkbox id="estado-2" v-model="terapia.estadoJson.issfa" switch />
          </b-form-group>
          <b-form-group class="col" label="Isspol:" label-for="estado-3">
            <b-form-checkbox id="estado-3" v-model="terapia.estadoJson.isspol" switch />
          </b-form-group>
          <b-form-group class="col" label="Particular:" label-for="estado-4">
            <b-form-checkbox id="estado-4" v-model="terapia.estadoJson.particular" switch />
          </b-form-group>
        </div>



        <b-row class="mt-3">
          <b-col>

            <b-button type="submit" class="float-right" variant="primary">
              Guardar
            </b-button>



          </b-col>
        </b-row>



      </b-form>
    </b-card>
  </div>

</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import vSelect from 'vue-select'


export default {

  name: "CrearEditarTerapia",
  components: { vSelect },

  props: {
    isVisible: {
      type: Boolean,
      default: false,
      required:false
    },

    tokenterapia: {
      type: String,
      default: null,
      required:false
    }
  },

  data() {
    return {
      localIsVisible: false,

      terapia: {
        codigo: '',
        nombre: '',
        tipoTerapiaId: null,
        precioJson: {
          issfa_n1: '',
          issfa_n2: '',
          iess_n1: '',
          particular: '',
          isspol_n1: '',
        },
        estadoJson: { issfa: true, isspol: true, iess: true, particular: true }


      },
      token: null,
      tipoTerapias: [],
    };
  },
  created() {
    this.fetchTiposTerapia();
  },

  methods: {

    soloNumeros(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      const isNumberOrDot = /^[0-9.]$/.test(char);

      // Solo permitir número o punto
      if (!isNumberOrDot) {
        event.preventDefault();
      }

      // Opcional: evitar más de un punto
      const input = event.target;
      if (char === '.' && input.value.includes('.')) {
        event.preventDefault();
      }
    },

    onCancel() {
      this.localIsVisible = false
    },

    convertTojson(jsonString) {
      try {
        if (!jsonString) return {};
        const jsonVariable = JSON.parse(jsonString);
        return jsonVariable || {};
      } catch (error) {
        console.log("error json", error);
        return {};
      }
    },


    async submitForm() {

      const query = `
       mutation ActualizarTerapia($terapiaDatos: TerapiaUpdateInput!) {
  actualizarTerapia(terapiaDatos: $terapiaDatos) {
    terapiaActualizado {
      nombre
      codigo
      estado
  


      estadoJson
      precioJson
   

    }
    message
    status
  }
}

      `;

      const variables = {
        terapiaDatos: {
          token: this.tokenterapia || null,
          datos: {
            nombre: this.terapia.nombre,
            codigo: this.terapia.codigo,
            // precioNeto: precioNetoFormateado,
            // precioTecho: precioNetoFormateado,
            //presentacion: this.terapia.presentacion,
            precioJson: JSON.stringify(this.terapia?.precioJson || {}),
            estadoJson: JSON.stringify(this.terapia?.estadoJson || {}),
            tipoTerapiaId: this.terapia.tipoTerapiaId || null,
          },
        },
      };

      try {
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: variables,
        });

        if (response.data.data.actualizarTerapia.status === "success") {
          this.localIsVisible = false
          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "El terapia se actualizó correctamente.",
          });

          this.$router.go(0)

        } else {
          throw new Error(response.data.data.actualizarTerapia.message);
        }
      } catch (error) {
        await this.$swal({
          icon: "error",
          title: "Error",
          text:
            error.message || "Hubo un problema al actualizar el terapia.",
        });
      }
    },

    async fetchConsultarterapia() {

      const query = `
       query ObtainTerapiaByToken($tokenterapia: String!) {
    obtainTerapiaByToken(tokenterapia: $tokenterapia) {
        message
        status
        terapia {
            id
            fechaCreacion
            ultimoCambio
            token
            nombre
            codigo
            estado
            numMax
            precio
            precioJson
            estadoJson
            tipoTerapia { id descripcion }
        }
    }
}
      `;
      const token = this.tokenterapia

      const varConsulta = {
        tokenterapia: token,
      }
      try {
        const response = await axios.post(
          rutas.axios + 'api',
          { query, variables: varConsulta }
        );

        if (response.status === 200) {
          if (response.data.data.obtainTerapiaByToken.status === 'Success') {
            if (response.data.data.obtainTerapiaByToken.terapia) {

              const terapia = response.data.data.obtainTerapiaByToken.terapia
              const precioJsonParsed = this.convertTojson(terapia.precioJson)
              const estadoJsonParsed = this.convertTojson(terapia.estadoJson)
              this.terapia = {
                id: terapia.id,
                nombre: terapia.nombre,
                codigo: terapia.codigo,
                estado: terapia.estado === '1' || terapia.estado === 1 ? true : false,
                precioNeto: terapia.precioNeto,
                precioJson: {
                  iess_n1   : precioJsonParsed.iess_n1   || '',
                  issfa_n1  : precioJsonParsed.issfa_n1  || '',
                  issfa_n2  : precioJsonParsed.issfa_n2  || '',
                  isspol_n1 : precioJsonParsed.isspol_n1 || '',
                  particular: precioJsonParsed.particular || '',
                },
                estadoJson: {
                  iess      : typeof estadoJsonParsed.iess === 'boolean' ? estadoJsonParsed.iess : true,
                  issfa     : typeof estadoJsonParsed.issfa === 'boolean' ? estadoJsonParsed.issfa : true,
                  isspol    : typeof estadoJsonParsed.isspol === 'boolean' ? estadoJsonParsed.isspol : true,
                  particular: typeof estadoJsonParsed.particular === 'boolean' ? estadoJsonParsed.particular : true,
                },
                tipoTerapiaId: (terapia.tipoTerapia && terapia.tipoTerapia.id) ? terapia.tipoTerapia.id : null,

              }

            } else {
              console.log("No se encontraron terapias");
            }
          } else {
            console.log("Error en la respuesta del servidor");
          }
        }
      } catch (error) {
        console.error("Error fetching terapias:", error);
      }
    },

    async fetchTiposTerapia() {
      const query = `
        query {
          allTipoterapias { id descripcion }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        const lista = (response && response.data && response.data.data && response.data.data.allTipoterapias)
          ? response.data.data.allTipoterapias
          : [];
        this.tipoTerapias = lista.map(item => ({ value: item.id, text: item.descripcion }));
      } catch (e) {
        console.error('Error cargando tipos de terapia', e);
      }
    },
  },

  watch: {
    tokenterapia: {
      deep:true,
      immediate:true,
      handler(newValue) {
        if(newValue){
        console.log("entra en new value token", newValue)
        this.fetchConsultarterapia();
        }
      }
     
    },


  }
};
</script>
